function isIndexInRange(list, index) {
  return index >= 0 && index < list.length;
}

function hasOrderProperty(entry) {
  return entry != null && typeof entry === 'object' && 'order' in entry;
}

function reindexOrderIfPresent(list) {
  if (!list.every(hasOrderProperty)) {
    return list;
  }

  return list.map((entry, order) => ({ ...entry, order }));
}

function reorderListItem(list, fromIndex, toIndex) {
  if (fromIndex === toIndex) {
    return list;
  }

  if (list.length < 2) {
    return list;
  }

  if (!isIndexInRange(list, fromIndex) || !isIndexInRange(list, toIndex)) {
    return list;
  }

  const next = [...list];
  const [movedItem] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, movedItem);
  return reindexOrderIfPresent(next);
}

function moveListItem(list, index, direction) {
  return reorderListItem(list, index, index + direction);
}

function toNamedEntries(fieldNames) {
  return fieldNames.map((name, order) => ({ name, order }));
}

function replaceSectionFieldNames(sections, sectionId, fieldNames) {
  return sections.map((section) => {
    if (section.sectionId !== sectionId) {
      return section;
    }

    return { ...section, fieldNames };
  });
}

function reorderSectionFieldNames(sections, sectionId, fromIndex, toIndex) {
  const targetSection = sections.find((section) => section.sectionId === sectionId);
  if (!targetSection) {
    return sections;
  }

  const namedEntries = toNamedEntries(targetSection.fieldNames);
  const reorderedEntries = reorderListItem(namedEntries, fromIndex, toIndex);
  if (reorderedEntries === namedEntries) {
    return sections;
  }

  const nextFieldNames = reorderedEntries.map((entry) => entry.name);
  return replaceSectionFieldNames(sections, sectionId, nextFieldNames);
}

export { moveListItem, reorderListItem, reorderSectionFieldNames };
